import CoursePlanEventLog from './CoursePlanEventLog';
export default CoursePlanEventLog;
